module.exports = __webpack_public_path__ + "static/img/example_yyzz.f2acdcc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/example_yyzz.jpg
// module id = wdsn
// module chunks = 128